import React, { FC } from 'react'

export const Card: FC = ({children}) => (
  <div className="card">
    {children}
  </div>
)